import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { RequestBudgetResponse, UpdateBudgetRequestDTO } from "@/types";

async function updateBudget({
  id,
  ...request
}: UpdateBudgetRequestDTO): Promise<RequestBudgetResponse> {
  const response = await httpRequest.put<RequestBudgetResponse>(
    `/budgets/${id}`,
    request
  );
  return response.data;
}

export function useUpdateBudgetMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateBudget,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["budgets"] });
    },
  });
}
